import React, { memo, useCallback, useMemo } from "react";

import { isEmpty } from "@swiggy-private/core-ui";

import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import ExtraCartItemInlineButton from "@cart-ui/components/food-item/components/ExtraCartItemInlineButton";
import { ItemPrice } from "@cart-ui/components/food-item/components/ItemPrice";

import {
    getActiveFooterTitleInfo,
    getButtonTitle,
    getNudgeFooterTitleInfo,
    getPlanForNudgeAnalytics,
    isActive,
} from "@cart-ui/helpers/OfferBundle";

import { IFooterTitleInfo, IFooterProps } from "../types";

import styles from "../styles/OfferPackNudgeWidget.scss";

const Footer = ({ item, onItemClick, analyticsEvents, isOfferPackAdded }: IFooterProps) => {
    const { title, variant, color }: IFooterTitleInfo = useMemo(() => {
        if (item.meta && isActive(item.meta) && !isEmpty(item.meta?.benefits)) {
            return getActiveFooterTitleInfo(item.meta);
        }
        return getNudgeFooterTitleInfo(item.meta);
    }, [item]);

    const onClick = useCallback(() => {
        analyticsEvents.clickNudge(
            getPlanForNudgeAnalytics(item.meta, item.type),
            getButtonTitle(item.meta, item.type),
        );

        onItemClick?.(item?.type?.toUpperCase(), item);
    }, [item, analyticsEvents, onItemClick]);

    if (!item) return null;

    return (
        <div className={styles.footer}>
            <Text variant={variant} color={color}>
                {title}
            </Text>
            {!isActive(item.meta) && (
                <div className={styles.footerActions}>
                    <ExtraCartItemInlineButton
                        onClick={onClick}
                        updating={false}
                        title={getButtonTitle(item.meta, item.type, isOfferPackAdded)}
                    />
                    <ItemPrice
                        itemPrice={item.meta?.plan_details?.base_price || 0}
                        finalPrice={item.meta?.plan_details?.final_price || 0}
                        freeQuantity={0}
                    />
                </div>
            )}
        </div>
    );
};

export default memo(Footer);
